module.exports = __webpack_public_path__ + "img/aircon_hot_on.96b73f9f.png";